import { render, staticRenderFns } from "./TableSupplier.vue?vue&type=template&id=3da73c74"
import script from "./TableSupplier.vue?vue&type=script&lang=js"
export * from "./TableSupplier.vue?vue&type=script&lang=js"
import style0 from "./TableSupplier.vue?vue&type=style&index=0&id=3da73c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports